import { Component, ChangeDetectionStrategy, inject, computed, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ThemeService } from '../../services/theme.service';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroComponent {
  private themeService = inject(ThemeService);
  private translationService = inject(TranslationService);
  private platformId = inject(PLATFORM_ID);
  
  private heroBgImageUrl = this.themeService.headerBgImageUrl;
  t = computed(() => this.translationService.t().hero);

  heroBgStyle = computed(() => 
    `linear-gradient(rgba(10, 10, 10, 0.7), rgba(10, 10, 10, 0.7)), url('${this.heroBgImageUrl()}')`
  );

  scrollToSection(event: MouseEvent, sectionId: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    event.preventDefault();
    
    const element = document.querySelector(sectionId);
    if (element) {
      const header = document.querySelector('header');
      const headerHeight = header ? header.offsetHeight : 80;
      
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerHeight;
    
      window.scrollTo({
         top: offsetPosition,
         behavior: "smooth"
      });

      // Update URL hash without causing a page jump
      if (history.pushState) {
        history.pushState(null, '', sectionId);
      }
    }
  }
}